import { render, staticRenderFns } from "./SearchPlaceInput.vue?vue&type=template&id=6c5748a4"
import script from "./SearchPlaceInput.vue?vue&type=script&lang=js"
export * from "./SearchPlaceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports